<div class="cf-dlg cim">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>upload_file</mat-icon></div>
    <div class="cim-header-text">
      <h2 class="cf-dlg-title">Importar conceptos</h2>
      <p class="cf-dlg-subtitle">Sube tus conceptos con nuestra plantilla Excel</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" type="button" (click)="closeDialog()" [disabled]="working"
      aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="working" [message]="loadingMessage"></app-loading-state>

  <ng-container *ngIf="!working && !dataReady && !imported">
    <div class="cf-dlg-body">
      <span class="cf-dlg-section__label">1. Descarga la plantilla</span>
      <p class="cim-hint">Rellena una fila por concepto con el nombre, los precios y las unidades.</p>

      <div class="cf-dlg-upload-zone">
        <button type="button" class="cf-dlg-upload-btn cim-tile" (click)="downloadTemplate()">
          <mat-icon>description</mat-icon>
          Plantilla vacía
        </button>
        <button type="button" class="cf-dlg-upload-btn cim-tile" (click)="downloadDemoTemplate()">
          <mat-icon>table_chart</mat-icon>
          Plantilla con ejemplo
        </button>
      </div>

      <span class="cf-dlg-section__label cim-section">2. Sube el archivo completado</span>
      <label class="cf-dlg-upload-btn cim-drop" for="concept-import-file" [class.cim-drop--over]="dragOver"
        (dragover)="onDragOver($event)" (dragleave)="dragOver = false" (drop)="onDrop($event)">
        <mat-icon>cloud_upload</mat-icon>
        <span class="cim-drop__title">Arrastra aquí el archivo o haz clic para seleccionarlo</span>
        <span class="cim-drop__hint">Excel (.xlsx) con el formato de la plantilla</span>
      </label>
      <input id="concept-import-file" type="file" accept=".xlsx" (change)="fileChange($event)" hidden />

      <div class="cim-alert" *ngIf="errorMessage">
        <mat-icon>error</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>

      <p class="cim-note">
        <mat-icon>info</mat-icon>
        Primero verás una vista previa: los conceptos no se añaden hasta que lo confirmes.
      </p>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" type="button" (click)="closeDialog()">
        <mat-icon>close</mat-icon> Cerrar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="!working && dataReady && !imported">
    <div class="cf-dlg-body">
      <span class="cf-dlg-section__label">3. Revisa y confirma</span>
      <p class="cim-hint">{{ selectedFileName }} · {{ dataSource.length }} concepto(s) listos para importar.</p>

      <div class="cim-alert" *ngIf="errorMessage">
        <mat-icon>error</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>

      <div class="cim-preview">
        <app-table [columns]="headerTable" [dataSource]="dataSource"></app-table>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <app-help key="Conceptos3"></app-help>
      <button mat-stroked-button class="cf-dlg-btn-secondary" type="button" (click)="reset()">
        <mat-icon>upload_file</mat-icon> Elegir otro archivo
      </button>
      <button mat-flat-button class="cf-dlg-btn-primary" type="button" (click)="addConcepts()"
        [disabled]="working || dataSource.length === 0">
        <mat-icon>add</mat-icon> Añadir conceptos
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="!working && imported">
    <div class="cf-dlg-body">
      <div class="cim-done">
        <div class="cim-done__icon"><mat-icon>check</mat-icon></div>
        <span class="cim-done__title">Conceptos añadidos</span>
        <span class="cim-done__file">{{ importedCount }} concepto(s) desde {{ selectedFileName }}</span>
        <span class="cim-done__hint">Ya están disponibles en el listado de conceptos.</span>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" type="button" (click)="reset()">
        <mat-icon>upload_file</mat-icon> Importar otro
      </button>
      <button mat-flat-button class="cf-dlg-btn-primary" type="button" (click)="closeDialog()">Hecho</button>
    </div>
  </ng-container>
</div>
